module.exports = __webpack_public_path__ + "img/team-solid.0c536476.svg";